// ✅ Dynamic API URL — works from localhost AND any network IP (192.168.x.x)
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://imselling-marketplace-production.up.railway.app/api';
  }
  return 'https://imselling-marketplace-production.up.railway.app/api';
};

const getMediaBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:8000';
  }
  return 'https://imselling-marketplace-production.up.railway.app';
};

export const API_BASE_URL = getApiBaseUrl();
export const MEDIA_URL = getMediaBaseUrl();


export const CATEGORIES = [
  'All',
  'Electronics',
  'Laptops, Phones & Accessories',
  'Vehicles',
  'Property',
  'Fashion & Clothing',
  'Health & Beauty',
  'Furniture & Home',
  'Rooms to Let',
  'Farm & Produce',
  'Food & Drinks',
  'Baby & Kids',
  'Books & Stationery',
  'Building & Construction',
  'Sports & Fitness',
  'Pets & Animals',
  'Art & Crafts',
  'Lost & Found',
  'Other',
];

// ── Sub-categories (optional, shown after category is selected) ────────────
export const SUB_CATEGORIES = {
  'Electronics': [
    'Blenders & Juicers', 'TVs & Displays', 'Audio & Speakers', 'Cameras',
    'Printers & Scanners', 'Networking & Wi-Fi', 'Gaming', 'Drones',
    'Smart Home Devices', 'Cables & Accessories', 'Batteries & Power Banks',
    'Other Electronics',
  ],
  'Laptops, Phones & Accessories': [
    'Smartphones', 'Laptops', 'Tablets', 'Feature Phones',
    'Phone Cases & Covers', 'Chargers & Cables', 'Earphones & Headsets',
    'Screen Protectors', 'Laptop Bags', 'Laptop Accessories',
    'Memory Cards & Storage', 'Other',
  ],
  'Vehicles': [
    'Cars', 'Motorcycles & Boda Boda', 'Trucks & Lorries', 'Buses & Matatus',
    'Tuk Tuks & Three Wheelers', 'Boats & Watercraft', 'Trailers',
    'Vehicle Parts & Accessories', 'Tyres & Rims', 'Other Vehicles',
  ],
  'Property': [
    'Houses for Sale', 'Land for Sale', 'Commercial Property',
    'Apartments for Sale', 'Plots', 'Beach Property', 'Other Property',
  ],
  'Fashion & Clothing': [
    'Men\'s Clothing', 'Women\'s Clothing', 'Kids\' Clothing',
    'Shoes - Men', 'Shoes - Women', 'Shoes - Kids',
    'Bags & Handbags', 'Watches', 'Sunglasses', 'Jewellery & Accessories',
    'Second-Hand (Mitumba)', 'Other Fashion',
  ],
  'Health & Beauty': [
    'Skincare', 'Hair Products', 'Makeup & Cosmetics', 'Perfumes & Fragrances',
    'Vitamins & Supplements', 'Medical Equipment', 'Gym & Fitness Equipment',
    'Massage & Spa', 'Other Health & Beauty',
  ],
  'Furniture & Home': [
    'Sofas & Couches', 'Beds & Mattresses', 'Tables & Chairs',
    'Wardrobes & Cabinets', 'Kitchen Appliances', 'Cookware & Utensils',
    'Curtains & Blinds', 'Lighting', 'Decor & Art', 'Other Furniture',
  ],
  'Farm & Produce': [
    'Crops & Grains', 'Fruits & Vegetables', 'Livestock',
    'Poultry', 'Dairy Products', 'Farm Equipment & Tools',
    'Seeds & Fertilizers', 'Irrigation Equipment', 'Other Farm',
  ],
  'Food & Drinks': [
    'Cooked Food', 'Snacks & Confectionery', 'Beverages',
    'Bakery & Cakes', 'Packaged Foods', 'Organic & Natural Foods',
    'Catering Services', 'Other Food',
  ],
  'Baby & Kids': [
    'Baby Clothes', 'Toys & Games', 'Baby Feeding',
    'Prams & Strollers', 'Baby Furniture', 'Learning & Education',
    'Kids\' Shoes', 'Other Baby & Kids',
  ],
  'Books & Stationery': [
    'Textbooks', 'Novels & Fiction', 'Business & Self Help',
    'Religious Books', 'Children\'s Books', 'Stationery & Supplies',
    'Magazines', 'Other Books',
  ],
  'Building & Construction': [
    'Cement & Building Materials', 'Tiles & Flooring',
    'Roofing Materials', 'Steel & Iron', 'Plumbing & Sanitary',
    'Electrical Materials', 'Paints & Finishes', 'Doors & Windows',
    'Construction Equipment', 'Other Building',
  ],
  'Sports & Fitness': [
    'Gym Equipment', 'Football & Team Sports', 'Running & Athletics',
    'Cycling', 'Swimming', 'Martial Arts', 'Outdoor & Camping',
    'Sports Clothing', 'Other Sports',
  ],
  'Pets & Animals': [
    'Dogs', 'Cats', 'Birds', 'Fish & Aquarium',
    'Pet Food', 'Pet Accessories', 'Veterinary Services',
    'Other Pets',
  ],
  'Art & Crafts': [
    'Paintings & Drawings', 'Sculpture', 'Photography',
    'Handmade Jewellery', 'Fabric & Textiles', 'Craft Supplies',
    'Musical Instruments', 'Other Art',
  ],
};

export const JOB_TYPES = [
  'Full-time',
  'Part-time',
  'Contract',
  'Internship',
  'Temporary'
];

export const SALARY_TYPES = [
  { value: 'year', label: 'Year' },
  { value: 'hour', label: 'Hour' }
];

export const ROUTES = {
  HOME:         'home',
  SHOPS:        'shops',
  JOBS:         'jobs',
  PLAY_TO_WIN:  'playtowin',
  WALLET:       'wallet',
  PROFILE:      'profile',
  ADMIN:        'admin',
  APP_VIEW:     'appview',
};